import ApplicationPage from './components/ApplicationPage';

const routes = [
  {
    path: '/application',
    name: 'menu.application',
    icon: 'application',
    customIcon: true,
    loginRequired: true,
    component: ApplicationPage,
    weight: 2,
    permission: [],
  },
];

export default routes;
